<template>
  <div class="product-page">
    <main id="main-content">
      <AiAccelerationHeroSection />
      <AiAccelerationFeaturesSection />
      <AiAccelerationPipelineSection />
      <AiAccelerationFrameworksSection />
      <AiAccelerationArchSection />
      <AiAccelerationCasesSection />
    </main>
  </div>
</template>

<script setup lang="ts">
import AiAccelerationArchSection from '@/components/ai-acceleration/AiAccelerationArchSection.vue';
import AiAccelerationCasesSection from '@/components/ai-acceleration/AiAccelerationCasesSection.vue';
import AiAccelerationFeaturesSection from '@/components/ai-acceleration/AiAccelerationFeaturesSection.vue';
import AiAccelerationFrameworksSection from '@/components/ai-acceleration/AiAccelerationFrameworksSection.vue';
import AiAccelerationHeroSection from '@/components/ai-acceleration/AiAccelerationHeroSection.vue';
import AiAccelerationPipelineSection from '@/components/ai-acceleration/AiAccelerationPipelineSection.vue';
import { useSeo } from '@/composables/useSeo';
import '@/styles/newhome/product-page.css';

useSeo({
  title: '海曦AI加速服务｜万卡级异构算力集群，大模型分布式训练、推理全链路算力加速解决方案',
  description:
    '搭建万卡级异构算力集群，采用200G/400G高速RDMA网络实现微秒级节点通信，兼容PyTorch、DeepSpeed等主流AI框架；覆盖数据准备、模型开发、分布式训练、推理部署全流程，配套任务监控、数据安全隔离能力，已有摩尔线程、中科院、商飞等落地案例，可大幅缩短AI研发周期、控制算力成本。'
});
</script>
